import { useQuery } from 'react-apollo';
import { ExchangeWorkingHoursQuery } from './__generated__/ExchangeWorkingHoursQuery';
import * as query from './query.gql';

export const useExchangeWorkingHours = () => {
  const { data, loading, refetch } = useQuery<ExchangeWorkingHoursQuery>(query);

  return {
    from: data?.stocksRemote.workingHours?.from,
    to: data?.stocksRemote.workingHours?.to,
    isOnline: data?.stocksRemote.workingHours?.isOnline,
    loading,
    refetch,
  };
};
